import { identifierModuleUrl } from '@angular/compiler';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'app/data.service';

export const passwordMatchValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const password1 = control.get('newPassword1');
  const password2 = control.get('newPassword2');

  return password1 && password2 && password1.value != password2.value ? { 'passwordMatch': true } : null
}

interface User{
  id: number,
  firstName: string,
  lastName: string,
  dob: string,
  email: string
}

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {

  userForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required])
  })

  passwordGroup: FormGroup

  userId: any

  constructor(public dialogRef: MatDialogRef<EditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User, private adminService: DataService, private notification: MatSnackBar) {
      let userObj = Object.assign({}, this.data)
      this.userId = this.data.id
      delete userObj['id']
      this.userForm.setValue(userObj)
    }

  ngOnInit(): void {
    this.passwordGroup  = new FormGroup({
      'newPassword1': new FormControl('', [Validators.required, Validators.minLength(8)]),
      'newPassword2': new FormControl('', [Validators.required]),
    }, { validators: passwordMatchValidator })
  }

  changePassword(passwordInstance){
    this.adminService.changeUserPassword(this.userId, passwordInstance.newPassword1).subscribe(data => {
      if(data.status){
        this.openNotification('Password has been changed!')
        this.dialogRef.close()
      }
    }, error => {
      if(error.status == 400){
        this.openNotification(error.error.message)
      }
    })
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  editUser(userInstance){
    this.adminService.editUser(this.userId, userInstance).subscribe(data => {
      if(data.status){
        this.openNotification('User has been updated')
        let user = data.user
        this.dialogRef.close(user)
      }
    }, error => {
      if(error.status == 400){
        this.openNotification(error.error.message)
      }
    })
  }

}
